export default function SuspenseFallback() {
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <div className="w-12 h-12 border-t-2 border-b-2 border-gray-500 rounded-full animate-spin"></div>
    </div>
  );
}
